import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getChapterQuadrants = async (params) => {
  const { chapterId } = params;

  const res = await axios.apiCadernoVirtual(
    "https://api.cadernovirtual.com.br/courses-service/content",
    {
      params: { chapterId },
    }
  );

  return res;
};

export const useChapterQuadrants = ({ config, chapterId } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["chapterQuadrants", { chapterId }],

    queryFn: () =>
      getChapterQuadrants({
        chapterId,
      }),
    enabled: !!chapterId,
  });
};
